import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../data/BaseUrl";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export const createNewCTO = createAsyncThunk(
  "api/createNewCTO",
  async ({ userData, authToken }) => {
    try {
      const response = await fetch(`${BASE_URL}/settelement/v2/cto`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: userData,
      });

      if (!response.ok) {
        throw new Error(
          "createNewCTO Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const uploadCreatCtoFile = createAsyncThunk(
  "api/uploadCreatCtoFile",
  async ({ fileData, authToken }) => {
    try {
      const response = await fetch(`${BASE_URL}/notification/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
        body: fileData,
      });

      if (!response.ok) {
        throw new Error(
          "uploadCreatCtoFile Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createNewCTOHead = createAsyncThunk(
  "api/createNewCTOHead",
  async ({ userData, authToken }) => {
    try {
      const response = await fetch(`${BASE_URL}/settelement/v2/cto-heads`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: userData,
      });

      if (!response.ok) {
        throw new Error(
          "createNewCTOHead Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const updateProfileShareDetails = createAsyncThunk(
  "api/updateProfileShareDetails",
  async ({ userData, authToken }) => {
    try {
      const response = await fetch(`${BASE_URL}/settelement/v2/manageshare`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: userData,
      });

      if (!response.ok) {
        throw new Error(
          "updateProfileShareDetails Request failed with status " +
            response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createDiscussion = createAsyncThunk(
  "api/createDiscussion",
  async ({ userData, authToken }) => {
    try {
      const response = await fetch(`${BASE_URL}/renewal/discussion`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
        body: userData,
      });

      if (!response.ok) {
        throw new Error(
          "createDiscussion Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createLog = createAsyncThunk(
  "api/createLog",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/renewal/discussion/logs`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: userData,
      });

      if (!response.ok) {
        throw new Error(
          "createLog Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createFetchPlans = createAsyncThunk(
  "api/createFetchPlans",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/gym/plan`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "createLog Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createPaymentLink = createAsyncThunk(
  "api/createPaymentLink",
  async ({ userData, token }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/subscription/draftorder/cashfree`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      if (!response.ok) {
        throw new Error(
          "createPaymentLink Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createPaymentLinkAdd = createAsyncThunk(
  "api/createPaymentLinkAdd",
  async ({ userData, token }) => {
    try {
      const response = await fetch(`${BASE_URL}/subscription/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "createPaymentLinkAdd Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const registerUser = createAsyncThunk(
  "api/registerUser",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/user/mobile/signup`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "registerUser Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const changePTTrainer = createAsyncThunk(
  "api/changePTTrainer",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/trainerandmember/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "changePTTrainer Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const changeTrainerShiftDays = createAsyncThunk(
  "api/changeTrainerShiftDays",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/staff/shift`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "changeTrainerShiftDays Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const changeTrainerShiftTimings = createAsyncThunk(
  "api/changeTrainerShiftTimings",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/trainerShift/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "changeTrainerShiftTimings Request failed with status " +
            response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addNewSubscription = createAsyncThunk(
  "api/addNewSubscription",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/subscription/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "addNewSubscription Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const updateSubscription = createAsyncThunk(
  "api/updateSubscription",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/subscription/update`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "updateSubscription Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const updatePayment = createAsyncThunk(
  "api/updatePayment",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/subscription/updatepayment`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "updatePayment Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

// Direct partial-installment collection (Cash / Online).
// Replaces the legacy paymentStatusUpdate path for pending partial rows that
// used to disappear into the cash_draft approval queue (see Rubal Dhaliwal
// ₹50K stuck since 2026-04). Body: { payment_uid, mode, trx_id? }.
export const collectPartialPayment = createAsyncThunk(
  "api/collectPartialPayment",
  async ({ userData, TOKEN }) => {
    const response = await fetch(`${BASE_URL}/subscription/partial/collect`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
    // Don't throw on !response.ok — backend returns structured {status,message}
    // for both 4xx (validation) and 5xx (server error); we want the caller to
    // surface that message to the user via toast.
    return await response.json();
  }
);

export const subscriptionDraftorderCashfree = createAsyncThunk(
  "api/subscriptionDraftorderCashfree",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/subscription/draftorder/cashfree`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      if (!response.ok) {
        throw new Error(
          "subscriptionDraftorderCashfree Request failed with status " +
            response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createNewMeal = createAsyncThunk(
  "api/createNewMeal",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/diet/add-diet`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          // "Content-Type": "multipart/form-data",
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "createNewMeal Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const updateMeal = createAsyncThunk(
  "api/updateMeal",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/diet/add-diet`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "multipart/form-data",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "updateMeal Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addNewKeyword = createAsyncThunk(
  "api/addNewKeyword",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/wati/add_predefined_msg/multiple`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      if (!response.ok) {
        throw new Error(
          "addNewKeyword Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const updateKeyword = createAsyncThunk(
  "api/updateKeyword",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/wati/update_predefined_msg`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "updateKeyword Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const uploadImage = createAsyncThunk(
  "api/uploadImage",
  async ({ file, TOKEN }) => {
    try {
      const formData = new FormData();
      formData.append("ingredient_image", file);

      const response = await fetch(
        `${BASE_URL}/diet/ingredient/upload_ingredient_img`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${TOKEN}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(
          "uploadImage Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addIngredient = createAsyncThunk(
  "api/addIngredient",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/diet/ingredient/add_multiple`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "addIngredient Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addDietTiming = createAsyncThunk(
  "api/addDietTiming",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/dietTiming/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "addDietTiming Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addPTTrack = createAsyncThunk(
  "api/addPTTrack",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/ptTrial/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          // "Content-Type": "application/json",
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "addPTTrack Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const userHandoverTrainer = createAsyncThunk(
  "api/userHandoverTrainer",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(
        `${BASE_URL}/ptTrial/assign_subs_to_trainer`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${TOKEN}`,
          },
          body: requestBody,
        }
      );

      if (!response.ok) {
        throw new Error(
          "userHandoverTrainer Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addDietTypes = createAsyncThunk(
  "api/addDietTypes",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/diettype/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "addDietTypes Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addDietician = createAsyncThunk(
  "api/addDietician",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/dietitian/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "addDietician Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addDietPackage = createAsyncThunk(
  "api/addDietPackage",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/dietcat/new/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "addDietPackage Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const createNewDietPlan = createAsyncThunk(
  "api/createNewDietPlan",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/dietpackage/add`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          // "Content-Type": "multipart/form-data",
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "createNewDietPlan Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const dietAssign = createAsyncThunk(
  "api/dietAssign",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/dietmapping/assignpackage`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "dietAssign Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addImportMember = createAsyncThunk(
  "api/addImportMember",
  async ({ userData, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/member/import/new`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(
          "addImportMember Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addStaffTarget = createAsyncThunk(
  "api/addStaffTarget",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/staff/target`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "addStaffTarget Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addGymTarget = createAsyncThunk(
  "api/addGymTarget",
  async ({ requestBody, TOKEN }) => {
    try {
      // const response = await fetch(`${BASE_URL}/settelement/v2/target`,
      const response = await fetch(
        `${BASE_URL}/settelement/v2/target/multiple-gym`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        throw new Error(
          "addGymTarget Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const addNewJob = createAsyncThunk(
  "api/addNewJob",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/campaign/initiate_obd`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "addPTTrack Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllGymPlans = createAsyncThunk(
  "api/getAllGymPlans",
  async ({ requestBody, TOKEN }) => {
    try {
      const response = await fetch(`${BASE_URL}/gym/plan`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "getAllGymPlans Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const apiSlice = createSlice({
  name: "postApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNewCTO.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewCTO.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewCTO.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createNewCTOHead.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewCTOHead.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewCTOHead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateProfileShareDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfileShareDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateProfileShareDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createDiscussion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDiscussion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createDiscussion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLog.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createFetchPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createFetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createFetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createPaymentLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPaymentLink.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createPaymentLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createPaymentLinkAdd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPaymentLinkAdd.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createPaymentLinkAdd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(changePTTrainer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePTTrainer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(changePTTrainer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(changeTrainerShiftDays.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeTrainerShiftDays.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(changeTrainerShiftDays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(changeTrainerShiftTimings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeTrainerShiftTimings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(changeTrainerShiftTimings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addNewSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addNewSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updatePayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updatePayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(subscriptionDraftorderCashfree.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(subscriptionDraftorderCashfree.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(subscriptionDraftorderCashfree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createNewMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addNewKeyword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addNewKeyword.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addNewKeyword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateKeyword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateKeyword.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateKeyword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addIngredient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addIngredient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addIngredient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addDietTiming.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDietTiming.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addDietTiming.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addPTTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPTTrack.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addPTTrack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(userHandoverTrainer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userHandoverTrainer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userHandoverTrainer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addDietTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDietTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addDietTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addDietician.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDietician.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addDietician.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addDietPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDietPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addDietPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(createNewDietPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewDietPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createNewDietPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(dietAssign.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dietAssign.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(dietAssign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addImportMember.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addImportMember.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addImportMember.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addStaffTarget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addStaffTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addStaffTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(addGymTarget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addGymTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addGymTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getAllGymPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllGymPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllGymPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default apiSlice.reducer;
